import { useTranslation } from "react-i18next";

const formatDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date)) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const ScenariosLogsOverviewTable = (data = []) => {
  const { t } = useTranslation();
  const columns = [
    { Header: t("scenarios.logs.columns.id"), accessor: "id", width: "15%" },
    { Header: t("scenarios.logs.columns.datetime"), accessor: "datetime", width: "30%" },
    { Header: t("scenarios.logs.columns.status"), accessor: "status", width: "25%" },
    { Header: t("scenarios.logs.columns.executionResult"), accessor: "execution_result", width: "30%" },
  ];

  const rows = data.map((item) => ({
    id: item.id ?? "-",
    datetime: formatDateTime(item.datetime),
    status: item.status ?? "-",
    execution_result: item.execution_result ?? "-",
  }));

  return { columns, rows };
};

export default ScenariosLogsOverviewTable;
